module.exports = __webpack_public_path__ + "static/media/royaljelly.b44c2c2a.webp";